module.exports = __webpack_public_path__ + "static/media/whybgtopside.be4d5c02.webp";